import emailCaptureConfig from '../components/EmailCapture.config.json';
import deriveRuntimeEnvironment from '../utils/deriveRuntimeEnvironment.js';

export default async function getClientToken() {
  const runtimeEnv = deriveRuntimeEnvironment();
  const { CNBC_BASE_URL } = emailCaptureConfig[runtimeEnv];

  const url = `${CNBC_BASE_URL}/api/auth/token`;
  const options = {
    method: 'POST',
    headers: { accept: 'application/json' },
    credentials: 'omit',
  };
  const response = await fetch(url, options);

  if (!response.ok) {
    return { isError: true, message: 'Failed to fetch client token' };
  }

  const json = await response.json();
  const { client_token: clientToken, expires_at: expiresAt } = json?.data || {};

  return {
    clientToken,
    expiresAt,
  };
}
